import React, { useEffect } from "react";
// ANT DESIGN COMPONENTS
import { DatePicker } from "antd";
// MOMENT DATE FORMAT
import moment from "moment";
// REDUX
import { useSelector, useDispatch } from "react-redux";
import { updateFilters } from "../../../redux/reports/reportsSlice";
// INTERFACES
import { RootState } from "../../../app/store";
import { ReportSliceFiltersInterface } from "../../../interfaces/Reports.interface";

function ReportsFilterDateDay() {
  // ************************************************ */
  // GLOBAL VARIABLES ******************************* */
  const dispatch = useDispatch();

  // ************************************************ */
  // USE STATE VARIABLES **************************** */

  // ************************************************ */
  // REDUX SLICE VARIABLES ************************** */
  const { filters, blockFilters } = useSelector((state: RootState) => state.report);

  // ************************************************ */
  // SERVICES AND API CALLS ************************* */

  // ************************************************ */
  // FUNCTIONS ************************************** */
  const onChange = (date: any, dateString: string) => {
    const copy: ReportSliceFiltersInterface = structuredClone(filters);
    copy.startDate = moment(dateString).startOf("day").format("YYYY-MM-DDTHH:mm:ss.SSS[Z]");
    copy.endDate = moment(dateString).endOf("day").format("YYYY-MM-DDTHH:mm:ss.SSS[Z]");
    dispatch(updateFilters(copy));
  };

  const generateDefaultTodayDate = () => {
    const copy: ReportSliceFiltersInterface = structuredClone(filters);
    copy.startDate = moment().startOf("day").format("YYYY-MM-DDTHH:mm:ss.SSS[Z]");
    copy.endDate = moment().endOf("day").format("YYYY-MM-DDTHH:mm:ss.SSS[Z]");
    dispatch(updateFilters(copy));
  };

  // ************************************************ */
  // USE EFFECT ************************************* */
  useEffect(() => {
    generateDefaultTodayDate();
  }, []);

  // ************************************************ */
  // COMPONENT ************************************** */
  return (
    <DatePicker
      className="generalStyles__width100"
      style={{ height: "24px" }}
      onChange={onChange}
      value={moment(filters.endDate)}
      allowClear={false}
      disabled={blockFilters}
    />
  );
}

export default ReportsFilterDateDay;
